import { Fragment } from 'react/jsx-runtime';
import { ReactComponent as PencilIcon } from '../../assets/pencil.svg';
import React from 'react';
import Skeleton from 'react-loading-skeleton';
import classNames from 'classnames';

export interface OverviewMetersProps {
  title: string;
  children: React.ReactNode;
  isDisabled?: boolean;
  isLoading?: boolean;
  onClickEdit?: () => void;
}
export default function OverviewMeters({
  title,
  children,
  isDisabled,
  isLoading,
  onClickEdit,
}: OverviewMetersProps) {
  const hasChildren = React.Children.count(children) > 0;
  return (
    <div className={classNames('overview-meters', { 'pt-0': !hasChildren })}>
      {hasChildren && (
        <div className="overview-meters__header">
          <h2>{title}</h2>
          {onClickEdit && (
            <PencilIcon
              role="button"
              className="icon overview-meters__header__edit-icon"
              onClick={onClickEdit}
            />
          )}
        </div>
      )}

      <ul
        className={classNames('overview-meters-list', {
          disabled: isDisabled,
        })}
      >
        {isLoading ? (
          <Fragment>
            {Array.from(Array(5).keys()).map((_, index) => (
              <div key={index} className="d-flex flex-column" style={{ width: 300, height: 130 }}>
                <div className="mb-4 d-flex flex-row align-items-center">
                  <div className="me-2">
                    <Skeleton circle count={1} height={24} width={24} />
                  </div>
                  <div>
                    <Skeleton className="mb-1" count={1} height={12} width={200} />
                    <Skeleton className="mb-2" count={1} height={8} width={150} />
                  </div>
                </div>
                <Skeleton className="mb-4" count={1} height={10} width={100} />
              </div>
            ))}
          </Fragment>
        ) : (
          children
        )}
      </ul>
    </div>
  );
}
